import { useTheme } from '@mui/material/styles';
import { useFlag } from '@unleash/proxy-client-react';
import { GenericSidebarHeader } from 'components/layout/Sidebar';
import { useGetAsset } from 'features/assetControl/hooks/useGetAsset';
import { Icons } from 'greener-ui-library';
import { useSidebarItems } from 'hooks/useSidebarItems';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { DEVICE_TYPE_IDS } from 'utils/constants';

export function useAssetSidebar() {
  const { t } = useTranslation();
  const { dispatchSidebar } = useSidebarItems();
  const { unitExternalIdentifier = '' } = useParams();
  const theme = useTheme();
  const { asset } = useGetAsset(unitExternalIdentifier);
  const isReportsPageEnabled = useFlag('assets-reports');
  const isReportingOnlyAsset = asset?.deviceType?.deviceTypeId === DEVICE_TYPE_IDS.REPORTING_ONLY_BATTERY;

  useEffect(() => {
    if (!dispatchSidebar) {
      return;
    }

    dispatchSidebar({
      type: 'REGULAR',
      payload: {
        sidebarHeader: <GenericSidebarHeader title={t('unitControl:domain')} subtitle={unitExternalIdentifier} />,
        items: [
          {
            isVisible: !isReportingOnlyAsset,
            name: t('unitControl:navigation.unitDetails'),
            path: `/assets/${unitExternalIdentifier}`,
            icon: () => <Icons.UnitControl strokeColor={theme.palette.secondary.main} />,
          },
          {
            isVisible: !isReportingOnlyAsset,
            name: t('unitControl:navigation.basicGraphs'),
            path: `/assets/${unitExternalIdentifier}/basic-graphs`,
            icon: () => <Icons.Graphs strokeColor={theme.palette.secondary.main} />,
          },
          {
            isVisible: !isReportingOnlyAsset,
            name: t('unitControl:navigation.advancedGraphs'),
            path: `/assets/${unitExternalIdentifier}/advanced-graphs`,
            icon: () => <Icons.Graphs strokeColor={theme.palette.secondary.main} />,
          },
          {
            isVisible: isReportingOnlyAsset && isReportsPageEnabled,
            name: t('unitControl:navigation.reports'),
            path: `/assets/${unitExternalIdentifier}/reports`,
            icon: () => <Icons.Report strokeColor={theme.palette.secondary.main} />,
          },
        ].filter((item) => item.isVisible),
      },
    });
  }, [dispatchSidebar, unitExternalIdentifier, t]);
}
